import {useMemo} from 'react';
import {SORT_KEYS, DEFAULT_SORT_KEY} from '../sortKeys';

export default function useSortedList(items, sortKey, direction) {
    return useMemo(() => {
        const key = SORT_KEYS[sortKey] ? sortKey : DEFAULT_SORT_KEY;
        if (key === 'manual') return items;
        const compare = SORT_KEYS[key].compare;
        const sorted = [...items].sort(compare);
        if (direction === 'desc') sorted.reverse();
        return sorted;
    }, [items, sortKey, direction]);
}
